import React, { Component } from 'react'

export default class Notfound extends Component {
    render() {
        return (
            <div>
                <p>You stumbled among the weeds</p>
            </div>
        )
    }
}
